import {GameStateEnums} from '../../../../../shared/GameEnums'
import {UIGameManager} from '../UIGameManager'
import {UIGameMechanic} from '../UIGameEventController'
import {PlayerValidator, MechanicValidatorLargestArmy, MechanicValidatorDevelopmentCard} from '@colonist/game-mechanic-validators'
import {ArrayUtils} from '../../../../../shared/utils/ArrayUtils'
import {CardEnum, MechanicDevelopmentCardsState, MechanicLargestArmyState, PlayerColor} from '@colonist/game-states'
import UIGameEventEnums = GameStateEnums.UIGameEventEnums
import {UIGameAddAchievementEvent} from '@colonist/ui-game'

export class UIGameLargestArmyController implements UIGameMechanic {
    protected readonly uiGameManager: UIGameManager
    private readonly largestArmyValidator: MechanicValidatorLargestArmy
    private readonly developmentCardsValidator: MechanicValidatorDevelopmentCard | undefined

    private lastPlayerToHoldLargestArmy: PlayerColor

    constructor(uiGameManager: UIGameManager, largestArmyState: MechanicLargestArmyState, developmentCardsState: MechanicDevelopmentCardsState | undefined) {
        this.uiGameManager = uiGameManager
        this.uiGameManager.eventController.registerUIGameMechanic(this)

        this.largestArmyValidator = new MechanicValidatorLargestArmy(this.uiGameManager.gameController.getPlayerValidators(), this.uiGameManager.gameController.mapValidator, largestArmyState)
        this.developmentCardsValidator = developmentCardsState ? new MechanicValidatorDevelopmentCard(this.uiGameManager.gameController.getPlayerValidators(), this.uiGameManager.gameController.mapValidator, this.uiGameManager.gameController.currentStateValidator, developmentCardsState) : undefined

        this.lastPlayerToHoldLargestArmy = this.largestArmyValidator.getPlayerWithLargestArmy()
    }

    onEvent(data: any, eventType: UIGameEventEnums) {
        switch(eventType) {
            case UIGameEventEnums.PlayerControllerStateUpdated: this.updateLargestArmyStatus(data); break
            default: break
        }
    }

    private updateLargestArmyStatus(animate: boolean) {
        for(const player of this.uiGameManager.gameState.players) {
            if(!this.largestArmyValidator.getLargestArmyPlayerState(player.color).hasLargestArmy) continue
            if(player.color == this.lastPlayerToHoldLargestArmy) continue

            this.playerAchievedLargestArmy(player, animate)
        }
    }

    private playerAchievedLargestArmy(playerState: PlayerValidator, animate: boolean) {
        const developmentCardsUsed = this.developmentCardsValidator?.getDevelopmentCardsPlayerState(playerState.color).developmentCardsUsed ?? []
        const knightDevelopmentCardsUsedCount = ArrayUtils.countOccurenceOfValueInArray(developmentCardsUsed, CardEnum.Knight)

        const achievement: UIGameAddAchievementEvent = {
            achievementOwnerNew: playerState.color,
            achievementOwnerPrevious: this.lastPlayerToHoldLargestArmy,
            achievementType: 'LargestArmy',
            achievementScore: knightDevelopmentCardsUsedCount,
        }

        this.lastPlayerToHoldLargestArmy = playerState.color

        this.uiGameManager.eventController.sendEvent(achievement, UIGameEventEnums.PlayerReceivedAchievement)
    }
}
